export default "__VITE_ASSET__DTVvNf_3__"